__turbopack_context__.v({
  "field": "PreOrderInfoField-module-scss-module__kIqq_q__field",
  "inline": "PreOrderInfoField-module-scss-module__kIqq_q__inline",
});
